// Convertit toute erreur (axios, throw, Pydantic 422, string…) en message
// lisible utilisable dans du JSX / toast. Ne renvoie JAMAIS d'objet ou tableau.
//
// Contexte : les erreurs de validation FastAPI/Pydantic ont la structure
// { detail: [{ type, loc, msg, input, url }, ...] }. Passé tel quel dans du
// JSX (par ex. <div>{error}</div>), React lève le minified error #31
// « object with keys {type, loc, msg, input, url} » et casse l'arbre → page
// blanche. Ce helper s'assure qu'on n'a jamais que des chaînes.
export function friendlyError(e) {
  if (!e) return "Erreur inconnue";
  if (typeof e === "string") return e;

  // Axios error → e.response.data.detail
  const data = e?.response?.data;
  const d = data?.detail ?? data;

  if (typeof d === "string") return d;

  if (Array.isArray(d)) {
    const parts = d.map((item) => {
      if (typeof item === "string") return item;
      if (item && typeof item === "object") {
        const loc = Array.isArray(item.loc)
          ? item.loc.filter((x) => x !== "body").join(".")
          : "";
        const msg = item.msg || item.message || item.type || "";
        return loc && msg ? `${loc} : ${msg}` : (msg || loc);
      }
      return "";
    }).filter(Boolean);
    return parts.length ? parts.join(" · ") : "Requête invalide";
  }

  if (d && typeof d === "object") {
    if (typeof d.msg === "string") return d.msg;
    if (typeof d.message === "string") return d.message;
    if (typeof d.detail === "string") return d.detail;
    try {
      return JSON.stringify(d).slice(0, 200);
    } catch {
      return "Erreur serveur";
    }
  }

  if (typeof e.message === "string") return e.message;
  return "Erreur inconnue";
}
